// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__Dza09 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0px 0;
  padding: 0 16px;
}
@media (max-width: 480px) {
  .styles_title__Dza09 {
    font-size: 24px;
  }
}

.styles_description__ZMMS1 {
  text-align: center;
  font-size: 16px;
  color: #666;
  margin: 0 0 0px 0;
  line-height: 1.5;
  padding: 0 16px;
}
@media (max-width: 480px) {
  .styles_description__ZMMS1 {
    font-size: 14px;
  }
}

.styles_infoMessage__WTUE3 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0px 0;
  color: #4285F4;
  font-size: 14px;
  padding: 0 16px;
  text-align: center;
}
.styles_infoMessage__WTUE3 .styles_infoIcon__vO2l3 {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.styles_infoMessage__WTUE3 span {
  opacity: 0.8;
}
@media (max-width: 480px) {
  .styles_infoMessage__WTUE3 {
    font-size: 13px;
  }
}

.styles_logoAndMessage__LIXVu {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 20px 0;
  min-height: 60px;
  padding: 0 16px;
  width: 100%;
  box-sizing: border-box;
}
@media (max-width: 480px) {
  .styles_logoAndMessage__LIXVu {
    flex-direction: column;
    gap: 12px;
  }
}

.styles_logo__hwrCu {
  width: 45px;
  height: 45px;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}
.styles_logo__hwrCu.styles_levitating__ORDKM {
  animation: styles_levitate__Mf3\\+s 2s ease-in-out infinite;
}
@media (max-width: 480px) {
  .styles_logo__hwrCu {
    width: 40px;
    height: 40px;
  }
}

@keyframes styles_levitate__Mf3\\+s {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
.styles_streamingText__kTzJV {
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
}
@media (max-width: 480px) {
  .styles_streamingText__kTzJV {
    font-size: 14px;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/streaming-loading/styles.module.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAAF;AAGE;EATF;IAUI,eAAA;EAAF;AACF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAAF;AAGE;EATF;IAUI,eAAA;EAAF;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAAJ;AAGE;EACE,YAAA;AADJ;AAKE;EAtBF;IAuBI,eAAA;EAFF;AACF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AAFF;AAKE;EAZF;IAaI,sBAAA;IACA,SAAA;EAFF;AACF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,+BAAA;AAFF;AAIE;EACE,0DAAA;AAFJ;AAME;EAXF;IAYI,WAAA;IACA,YAAA;EAHF;AACF;;AAMA;EACE;IACE,wBAAA;EAHF;EAKA;IACE,4BAAA;EAHF;AACF;AAMA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAJF;AAOE;EARF;IASI,eAAA;IACA,kBAAA;EAJF;AACF","sourcesContent":["@import \"mixins\";\n.title {\n  text-align: center;\n  font-size: 32px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0 0 0px 0;\n  padding: 0 16px;\n\n  // Mobile: smaller title\n  @media (max-width: 480px) {\n    font-size: 24px;\n  }\n}\n\n.description {\n  text-align: center;\n  font-size: 16px;\n  color: #666;\n  margin: 0 0 0px 0;\n  line-height: 1.5;\n  padding: 0 16px;\n\n  // Mobile: smaller description\n  @media (max-width: 480px) {\n    font-size: 14px;\n  }\n}\n\n.infoMessage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0px 0;\n  color: #4285F4;\n  font-size: 14px;\n  padding: 0 16px;\n  text-align: center;\n\n  .infoIcon {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n  }\n\n  span {\n    opacity: 0.8;\n  }\n\n  // Mobile: smaller text\n  @media (max-width: 480px) {\n    font-size: 13px;\n  }\n}\n\n.logoAndMessage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin: 20px 0;\n  min-height: 60px;\n  padding: 0 16px;\n  width: 100%;\n  box-sizing: border-box;\n\n  // Mobile: stack vertically\n  @media (max-width: 480px) {\n    flex-direction: column;\n    gap: 12px;\n  }\n}\n\n.logo {\n  width: 45px;\n  height: 45px;\n  flex-shrink: 0;\n  transition: transform 0.3s ease;\n\n  &.levitating {\n    animation: levitate 2s ease-in-out infinite;\n  }\n\n  // Mobile: slightly smaller logo\n  @media (max-width: 480px) {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n@keyframes levitate {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.streamingText {\n  font-size: 16px;\n  color: #333;\n  line-height: 1.5;\n  text-align: left;\n  word-break: break-word;\n\n  // Mobile: center text and smaller font\n  @media (max-width: 480px) {\n    font-size: 14px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__Dza09`,
	"description": `styles_description__ZMMS1`,
	"infoMessage": `styles_infoMessage__WTUE3`,
	"infoIcon": `styles_infoIcon__vO2l3`,
	"logoAndMessage": `styles_logoAndMessage__LIXVu`,
	"logo": `styles_logo__hwrCu`,
	"levitating": `styles_levitating__ORDKM`,
	"levitate": `styles_levitate__Mf3+s`,
	"streamingText": `styles_streamingText__kTzJV`
};
export default ___CSS_LOADER_EXPORT___;
